import React from "react"
import {Button, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid2";
import {getLocale, getTranslatatedPropertyValue} from "../../../Utils/helpers";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";

interface PrivacyPolicyProps {
    onClose: () => void
}

const PrivacyPolicy = ({onClose}: PrivacyPolicyProps) => {
    const { t } = useTranslation()
    const language = getLocale()

    const privacyPolicy = useSelector((state: RootState) => getTranslatatedPropertyValue(state.ui.settings.selfService, 'privacyPolicy', language))

    return <>
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={2} className={'pageMainContainer'}>
            <Typography variant="h3" gutterBottom>{t('selfService.privacyPolicy')}</Typography>
            <Grid size="grow" style={{width: '100%', marginTop: -8, overflowY: 'auto'}}>
                <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
            </Grid>
            <Button
                variant="contained"
                color="secondary"
                onClick={onClose}
            >
                {t('common.close')}
            </Button>
        </Grid>
    </>
}

export default PrivacyPolicy
